import { observer } from "mobx-react-lite";

import { twMerge } from "@/utils/twMerge";

import { useFileDroppable } from "./useFileDroppable";

export const Droppable = observer(function Droppable({
  id,
  type,
  parentId,
  position,
  variant = "line",
  className,
  disabled,
  children,
  compensateHeight,
  isOverlay: _,
  ...rest
}: {
  id: string;
  type: "file" | "folder";
  className?: string;
  isOverlay?: boolean;
  parentId?: string;
  position?: number;
  disabled?: boolean;
  variant?: "line" | "border";
  children?: React.ReactNode;
  compensateHeight?: boolean;
} & React.HTMLAttributes<HTMLDivElement>) {
  const { active, isFileDragging, isOver, setNodeRef } = useFileDroppable({
    id,
    disabled,
    data: {
      id,
      type,
      parentId,
      position,
    },
  });

  // Same element shape as the enabled branch so toggling `disabled` keeps children mounted
  if (disabled) {
    return (
      <>
        {false}
        <div {...rest}>
          <div>
            {false}
            {children}
          </div>
        </div>
      </>
    );
  }

  const showDraggedItemPlaceholder =
    !!active &&
    active?.id !== id &&
    typeof position === "number" &&
    (active?.data?.current?.parentId !== parentId || active?.data?.current?.position !== position);

  const showPlaceholder = showDraggedItemPlaceholder || isFileDragging;

  return (
    <>
      {compensateHeight && <div className="-mt-[20px]" />}
      <div
        ref={setNodeRef}
        className={twMerge(
          isOver && showPlaceholder && variant === "border" && "ring-2 ring-blue-500 rounded-6",
          variant === "line" && "-translate-y-[5px]",
          className,
        )}
        {...rest}
      >
        <div className={twMerge(variant === "line" && "translate-y-[5px]")}>
          {(active || isFileDragging) && variant === "line" && (
            <div className="relative w-full">
              <div
                className={twMerge(
                  "absolute left-5 right-1",
                  isOver && showPlaceholder && "border border-blue-500 border-solid",
                )}
              />
            </div>
          )}
          {children}
        </div>
      </div>
    </>
  );
});
